import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const getCurrenciesFunc = createAsyncThunk(
  "getCurrencies",
  async (apiUrl = "", thunkAPI) => {
    try {
      const response = await api.get(`dashboard/currencies${apiUrl}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const getCurrenciesSlicer = createSlice({
  name: "getCurrencies",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCurrenciesFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getCurrenciesFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data?.currencies || action.payload?.currencies || [];
        state.successMessage = action.payload?.message || "";
      })
      .addCase(getCurrenciesFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getCurrenciesSlicer.reducer;
